import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteConfirmationDialog',
  props: {
    modelValue: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "close-on-back": false,
    width: "auto",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:model-value', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        "max-width": "500",
        variant: "flat",
        class: "pa-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "title")
            ]),
            _: 3
          }),
          _createVNode(_component_v_card_text, { class: "px-4 pt-1" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "text")
            ]),
            _: 3
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:model-value', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Отменить ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "red-accent-4",
                variant: "outlined",
                class: "ml-6",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('agree', false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Подтвердить ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["model-value"]))
}
}

})